import React, { useContext } from 'react';

export const FeatureFlagsContext = React.createContext<Record<string, boolean>>({});

export const useFeatureFlags = (): Record<string, boolean> => useContext(FeatureFlagsContext);
